import { IRailcarWithCarMark } from '../railcar/i-railcarwithcarmark.interface';
import { IRailcar } from '../railcar/i-railcar.interface';
import { IFacility } from '../facility/i-facility.interface';
import { ILease } from '../lease/i-lease.interface';
import { IRailcarStorageHistory } from './i-railcarstoragehistory.interface';

import { BusinessObject } from '../../shared/business-object.model';

export class RailcarStorageHistory extends BusinessObject implements IRailcarStorageHistory {
	//railcar: IRailcarWithCarMark;
	railcar: IRailcar;
	storageLocation: IFacility;
	storageLocationId: number;
	startDate: Date;
	endDate: Date;
	dailyStorageFee: number;
  currentFeeEffectiveDate?: Date;
	feeEffectiveDate?: Date;
	dailyStorageRateOverrides?: { effectiveDate: Date; endDate?: Date; dailyStorageFee: number }[];
	fromLease: ILease;
	toLease: ILease;

	constructor(history?: RailcarStorageHistory) {
		if (history) {
			if (history.startDate) {
				history.startDate = new Date(history.startDate);
			}
			if (history.endDate) {
				history.endDate = new Date(history.endDate);
			}
			if (history.currentFeeEffectiveDate) {
				history.currentFeeEffectiveDate = parseDateOnlyToLocal(history.currentFeeEffectiveDate);
			}
			if (history.feeEffectiveDate) {
				history.feeEffectiveDate = parseDateOnlyToLocal(history.feeEffectiveDate);
			}
			if (history.dailyStorageRateOverrides?.length) {
				history.dailyStorageRateOverrides = history.dailyStorageRateOverrides.map(f => ({
					...f,
					effectiveDate: f.effectiveDate ? parseDateOnlyToLocal(f.effectiveDate) : f.effectiveDate,
					endDate: f.endDate ? parseDateOnlyToLocal(f.endDate) : f.endDate
				}));
			}
		}
		super(history);
	}
}

/** Parse yyyy-MM-dd (or ISO prefix) into a local calendar Date — stable in any timezone. */
export function parseDateOnlyToLocal(value: Date | string): Date {
	const parts = getDateOnlyParts(value);
	if (!parts) {
		return value instanceof Date ? value : new Date(value);
	}
	return new Date(parts.y, parts.m, parts.d);
}

export function getDateOnlyParts(value: Date | string): { y: number; m: number; d: number } | null {
	if (value == null) {
		return null;
	}
	if (typeof value === 'string') {
		const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
		if (match) {
			return { y: +match[1], m: +match[2] - 1, d: +match[3] };
		}
	}
	const d = value instanceof Date ? value : new Date(value);
	if (isNaN(d.getTime())) {
		return null;
	}
	// Datepicker / already-local calendar dates: use local Y/M/D (the user's selected day).
	return { y: d.getFullYear(), m: d.getMonth(), d: d.getDate() };
}

export function toDateOnlyString(value: Date | string): string {
	const parts = getDateOnlyParts(value);
	if (!parts) {
		return '';
	}
	const mm = (parts.m + 1).toString().padStart(2, '0');
	const dd = parts.d.toString().padStart(2, '0');
	return `${parts.y}-${mm}-${dd}`;
}

export function formatDateOnlyDisplay(value: Date | string): string {
	const parts = getDateOnlyParts(value);
	if (!parts) {
		return '';
	}
	const mm = (parts.m + 1).toString().padStart(2, '0');
	const dd = parts.d.toString().padStart(2, '0');
	return `${mm}/${dd}/${parts.y}`;
}
